import React, { useState, useEffect } from "react";
import "../styles.css";
import { loadScoresFromLocal, saveScoresToLocal } from "../scores";

import EmptyTask from "../images/empty-task.png"
import { getTasks, getTasksPull } from "../helpers";
import { get_random } from "../openBoosters";

const tasksList = getTasks();
const dailyTaskLimit = 10;
const dailyTaskResetTime = 20 * 60 * 60 * 1000 // 20 hours

export default function Tasks() {
  const [currentTask, setCurrentTask] = useState(null);
  const [scores, setScores] = useState(loadScoresFromLocal());
  const [taskCount, setTaskCount] = useState(0);
  
  useEffect(() => {
    const lastTaskTimestamp = localStorage.getItem("lastTaskTimestamp");
    const storedTaskCount = localStorage.getItem("taskCount");
    
    if (lastTaskTimestamp) {
      const now = new Date().getTime();
      if (now - parseInt(lastTaskTimestamp) < dailyTaskResetTime) {
        setTaskCount(parseInt(storedTaskCount));
      } else {
        localStorage.removeItem("taskCount");
      }
    }
  }, []);
  
  const getRandomTask = () => {
    if (taskCount < dailyTaskLimit) {
      const pull = getTasksPull();
      const randomTask = get_random(pull);
      console.log(randomTask - 1)
      setCurrentTask(tasksList[randomTask-1]);
      setTaskCount(taskCount + 1);
      localStorage.setItem("lastTaskTimestamp", new Date().getTime());
      localStorage.setItem("taskCount", taskCount + 1);
    } else {
      alert("You have reached your daily limit of 10 tasks.");
    }
  };

  const handleDone = () => {
    if (currentTask) {
      setScores(scores + currentTask.score);
      saveScoresToLocal(scores + currentTask.score);
      setCurrentTask(null);
    }
  };

  const handleFailed = () => {
    setScores(scores - currentTask.negativeScore);
    saveScoresToLocal(scores - currentTask.score);
    setCurrentTask(null); // Clear current task
  };

  const remainingTasks = dailyTaskLimit - taskCount;

  return (
    <div>
      <div className="">
        {currentTask ? (
          <>
            <div className="">
              <img src={require(`../images/tasks/${currentTask.image}`)} alt="Task" />
            </div>
            <div className="wrapperTaskButton">
              <button className="failedTaskButton" onClick={handleFailed}>Failed</button>
              <button className="doneTaskButton" onClick={handleDone}>Done</button>
            </div>
          </>
        ) : (
          <>
            <div className="">
              <img src={EmptyTask} alt="Task" />
            </div>
            <button className="getTaskButton" onClick={getRandomTask}>Get my task</button>
          </>
        )}
      </div>
      <div className="scoreContainer">
        <p className="scoreText">Scores: {scores}</p>
        <p className="taskCountText">Tasks left today: {remainingTasks}</p>
      </div>
    </div>
  );
}
